import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import BulkImportVehiclesTab from './BulkImportVehiclesTab';
import BulkImportTagsTab from './BulkImportTagsTab';
import BulkImportIdentificationTagsTab from './BulkImportIdentificationTagsTab';

const VALID_TABS = ['vehicles', 'tags', 'identificationtags'] as const;

const BulkImportScreen: React.FC = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    const activeTab = VALID_TABS.includes(tabParam as any) ? tabParam! : 'vehicles';

    const onTabSelect = (key: string | null) => {
        if (!key) return;
        setSearchParams({ tab: key }, { replace: true });
    };

    return (
        <ScreenTitle title={t('bulkImport.title')}>
            <Breadcrumb>
                <Breadcrumb.Item active>{t('bulkImport.title')}</Breadcrumb.Item>
            </Breadcrumb>
            <Tabs activeKey={activeTab} onSelect={onTabSelect} className="mb-3" fill>
                <Tab eventKey="vehicles" title={t('bulkImport.tab_vehicles')}>
                    <BulkImportVehiclesTab />
                </Tab>
                <Tab eventKey="tags" title={t('bulkImport.tab_tags')}>
                    <BulkImportTagsTab />
                </Tab>
                <Tab eventKey="identificationtags" title={t('bulkImport.tab_identification_tags')}>
                    <BulkImportIdentificationTagsTab />
                </Tab>
            </Tabs>
        </ScreenTitle>
    );
};

export default BulkImportScreen;
